module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"dataEntry":"Datenerfassung"},"en":{"dataEntry":"Data entry"}}')
  delete Component.options._Ctor
}
